export default __webpack_public_path__ + "static/media/application_check.3e5d7d10.svg";